module.exports = __webpack_public_path__ + "img/malka-l0m2p_k5VJ8-unsplash.1cf61daa.jpg";